import Animation from "../animations/Animation";
import { setIntersectionObserver } from "../helpers";

/**
 * A custom element class for accessing window events and associated callbacks
 * @extends HTMLElement
 * @property {Function} onAnimate a callback function for animation complete
 * @property {Function} onResized a callback function for window.resize (or element resize)
 * @property {Function} onScroll a callback function bound to scroll
 * @property {Function} onViewportEnter a callback function for intersectionObserver inViewport: true
 * @property {Function} onViewportExit a callback function for intersectionObserver inViewport: false
 */
export default class CustomElement extends HTMLElement {

	constructor() {

		super();

		/**
		 * @member {boolean} hasEntered
		 * @member {boolean} resetOnExit
		 */
		this.hasEntered = false;
		this.resetOnExit = false;

		/** --- Setup observer --- */
		window.Zero.observer = window.Zero.observer || setIntersectionObserver();

		/** --- Grab events objects --- */
		window.Zero.events.resized = window.Zero.events.resized || [];
		window.Zero.events.observed = window.Zero.events.observed || [];

		/** --- only bind if needed --- */
		if (this.onAnimate) this.addEventListener("animate", this.onAnimate.bind(this));
		if (this.onResized) {

			window.Zero.events.resized.push(this);

			this.addEventListener("resized", this.onResized.bind(this));
		}

		if (this.dataset.animation !== undefined) return;

		if (this.onViewportEnter || this.onViewportExit) {

			window.Zero.events.observed.push(this);
			window.Zero.observer.observe(this);
		}

		if (this.onViewportEnter) this.addEventListener("viewportEnter", this.onViewportEnter.bind(this));
		if (this.onViewportExit) this.addEventListener("viewportExit", this.onViewportExit.bind(this));


		/** Bind global animation attribute */

		// this.animation = new Animation()


	}
}
